import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon, FileTextIcon, StarIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-black py-4 md:py-6 px-4 overflow-hidden" data-id="element-183">
      <div className="max-w-3xl mx-auto text-center" data-id="element-184">
        <div className="inline-flex items-center gap-1.5 bg-[#22c55e]/10 border border-[#22c55e]/30 text-[#22c55e] px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-185">
          <StarIcon className="w-3 h-3 fill-[#22c55e]" data-id="element-186" />
          El recurso #1 para docentes de Educación Financiera
          <StarIcon className="w-3 h-3 fill-[#22c55e]" data-id="element-187" />
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.1] mb-3" data-id="element-188">
          Todo tu año de educación financiera{' '}
          <span className="text-[#22c55e] italic" data-id="element-189">resuelto.</span>
        </h1>

        <div className="my-2 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300" onClick={scrollToPricing} data-id="element-190">
          <img src="https://cdn.magicpatterns.com/uploads/jWH4PQNFuxYkhHLKacbA2K/conjunto_de_mockups_educacion_financiera_.png" alt="Kit Completo Educación Financiera" className="w-full max-w-md mx-auto drop-shadow-2xl" data-id="element-191" />
        </div>

        <p className="text-[#22c55e] font-bold text-xl md:text-2xl italic mb-1" data-id="element-192">
          "Listo para usar. Sin buscar más."
        </p>

        <p className="text-gray-300 text-base md:text-lg mb-3 max-w-xl mx-auto" data-id="element-193">
          El sistema que usan los docentes de educación financiera en Argentina
          para planificar{' '}
          <span className="font-bold text-white underline decoration-[#22c55e] underline-offset-4" data-id="element-194">
            todo el año en una tarde
          </span>
        </p>

        <div className="flex items-center justify-center gap-3 mb-2" data-id="element-195">
          <span className="flex items-center gap-1 text-gray-400 text-[11px] font-semibold whitespace-nowrap" data-id="element-196">
            <FileTextIcon className="w-2.5 h-2.5 text-[#22c55e]" data-id="element-197" /> 100% PDF
          </span>
          <span className="text-gray-600 text-[10px]" data-id="element-198">•</span>
          <span className="flex items-center gap-1 text-gray-400 text-[11px] font-semibold whitespace-nowrap" data-id="element-199">
            <ZapIcon className="w-2.5 h-2.5 text-[#22c55e]" data-id="element-200" /> Acceso inmediato
          </span>
          <span className="text-gray-600 text-[10px]" data-id="element-201">•</span>
          <span className="flex items-center gap-1 text-gray-400 text-[11px] font-semibold whitespace-nowrap" data-id="element-202">
            🇦🇷 Currículo argentino
          </span>
        </div>

        <div className="flex justify-center mb-1" data-id="element-203">
          <CTAButton onClick={scrollToPricing} className="text-sm px-5 py-2.5 whitespace-nowrap" data-id="element-204">
            → QUIERO MI KIT COMPLETO AHORA
          </CTAButton>
        </div>

        <div className="flex items-center justify-center gap-2 text-[9px] md:text-[10px] text-gray-500 font-medium" data-id="element-205">
          <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-206">
            <ShieldCheckIcon className="w-2.5 h-2.5 text-green-600" data-id="element-207" /> Garantía
            7 días
          </span>
          <span className="text-gray-600" data-id="element-208">•</span>
          <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-209">
            <LockIcon className="w-2.5 h-2.5 text-green-600" data-id="element-210" /> Pago 100% seguro
          </span>
          <span className="text-gray-600" data-id="element-211">•</span>
          <span className="flex items-center gap-0.5 whitespace-nowrap" data-id="element-212">
            <CreditCardIcon className="w-2.5 h-2.5 text-green-600" data-id="element-213" /> Mercado
            Pago
          </span>
        </div>
      </div>
    </section>;
}